<template>
  <div class="pr-6">
    <div class="hr-line col-sm-12 col-xs-12 col-md-12 p-0">
      <hr class="mb-26"/>
    </div>
    <div class="col-xs-12">
      <p class="billing-info">{{$t('billingInformation')}}</p>
    </div>
    <div class="col-sm-12 col-xs-12 team-wrapper">
      <div class="col-xs-12 col-sm-6 col-sm-push-6">
        <div class="col-xs-12 col-sm-10" style="padding-top:10px;text-align:center;">
          <div
              class="profile-pic-edit profile-pic-title-edit"
            ><span class="d-flex initials">{{getInitials(team.first_name, team.last_name)}}</span></div>
        </div>
      </div>
      <div class="col-sm-6 col-sm-pull-6 col-xs-12">
        <div class="row mr-bt-28">
          <div class="field-name col-sm-12 col-xs-12 col-md-12">{{ $t('firstName')}}</div>
          <div class="col-sm-12 col-xs-12 col-md-10">
            <input type="text" :placeholder="$t('enterFirstName')" class="form-control" v-model.trim="team.first_name" maxlength="35"/>
          </div>
        </div>
        <div class="row mr-bt-28">
          <div class="field-name col-sm-12 col-xs-12 col-md-12">{{ $t('lastName')}}</div>
          <div class="col-sm-12 col-xs-12 col-md-10">
            <input type="text" :placeholder="$t('enterLastName')" class="form-control" v-model.trim="team.last_name" maxlength="30"/>
          </div>
        </div>
        <div class="row mr-bt-28">
          <div class="field-name col-sm-12 col-xs-12 col-md-12">Email</div>
          <div class="col-sm-12 col-xs-12 col-md-10">
            <input
              type="text"
              :placeholder="$t('enterEmail')"
              class="form-control"
              v-model="team.email"
              maxlength="65"
              @blur="emailVal"
            />
            <div
              v-if="this.addMemberError.length"
              class="validation-message"
              style="padding-left: 2px;font-size: 14px;float: left;"
            >{{this.addMemberError}}</div>
            <div v-if="displayEmailErrorMsg" class="custom-error-class">
              <span class="error-message-response">{{ $t('invalidEmail')}}</span>
              <br />
            </div>
          </div>
        </div>
        <div class="row mr-bt-28" v-if="multi_factor_key">
          <div class="field-name col-sm-12 col-xs-12 col-md-12">{{ $t('IpAddress')}}</div>
          <div class="col-sm-12 col-xs-12 col-md-10">
            <input
              type="text"
              :placeholder="$t('IpAddressLabel')"
              class="form-control"
              v-model="team.ip_address"
              @blur="ipAddressVal"
            />
        </div>
        </div>
        <div class="row mb-77">
          <div class="field-name col-sm-12 col-xs-12 col-md-12">{{ $t('role')}}</div>
          <div class="col-sm-12 col-xs-12 col-md-10 custom-dropdown">
            <multiselect
              :showLabels="false"
              :close-on-select="true"
              :allow-empty="false"
              class="product-class-ellipsis multiselect-single-dropdown"
              :searchable="false"
              openDirection="below"
              :options="roles.map(role => role.id)"
              :custom-label="option => roles.find(x => x.id === option).name"
              v-model="team.role"
              @input="getRoleBasedTemplate(team.role)"
              :placeholder="$t('selectRole')"
            >
          </multiselect>
          </div>
        </div>
        <div class="row mr-bt-28" v-if="team.role== '6'">
          <div class="field-name col-sm-12 col-xs-12 col-md-12">{{ $t('distributor')}}</div>
          <div class="col-sm-12 col-xs-12 col-md-10 custom-dropdown">
            <multiselect
              :disabled="team.role!= '6'"
              :showLabels="false"
              :close-on-select="true"
              :allow-empty="false"
              class="multiselect-single-dropdown"
              :searchable="false"
              :options="localDistributors.map(distributor => distributor.id)"
              :custom-label="option => localDistributors.find(x => x.id === option).distributor_name"
              v-model="team.assigned_distributor_id"
              :placeholder="$t('selectDistributor')"
            >
          </multiselect>
          </div>
        </div>
      </div>
      <div class="col-md-12 col-sm-12 col-xs-12 mr-bt-5p serviceAccess" v-if="userServiceList.length && complianceServices.length && this.permissions.indexOf('REG_TRACKER_RECORDS') !== -1">
        <h4 class="serviceAccessText">{{ $t('servicesAccess')}}</h4>
        <hr class="horizontalLineOne"/>
        <div class="complianceTrackerOuter">
          <ul>
            <li class="main-content" v-for="(service, index) in userServiceList" :key="index">
              <div class="row">
                <div class="col-xs-12 complianceTracker">
                  <div class="col-xs-8 col-sm-8 col-md-8 pl-10 greenCheckMark">
                    <img src="/static/images/icons/green_circle_check.svg" alt="" class="img">
                    <h4 class="complianceTrackerText">{{service.name}}</h4>
                  </div>
                  <div class="col-xs-4 complianceTrackerCarret">
                    <span>
                      <button data-toggle="collapse" data-target="#collapseComplianceTracker" data-parent="#accordion">
                        <img src="/static/images/icons/account_settings_arrow.svg" class="downCarret" />
                        <img src="/static/images/icons/account_settings_arrow.svg" class="upCarret" />
                      </button>
                    </span>
                  </div>
                </div>
              </div>
              <div class="collapse" id="collapseComplianceTracker">
                <ul>
                  <li class="main-content" v-for="(service_module, ind) in service.modules" :key="ind">
                    <div class="row pt-10">
                      <div class="complianceTrackerRecords pb-8">
                        <div class="form-check d-flex col-xs-8 col-sm-8 mt-35">
                          <label class="custom-checkbox">
                            <input type="checkbox" id="records" v-model="complianceServices[index][service.key].parent" @change="toggleRecords('parent',service.key,index)" />
                            <span class="select-check"></span>
                          </label>
                          <span class="pl-24 module-name">{{service_module.name}}</span>
                        </div>
                        <div class="carretTwo col-xs-8 col-sm-4">
                          <span>
                            <button data-toggle="collapse" class="pt-40" data-target="#collapseComplianceTrackerRecords" data-parent="#accordion">
                              <img src="/static/images/icons/account_settings_arrow.svg" class="downCarret" />
                              <img src="/static/images/icons/account_settings_arrow.svg" class="upCarret" />
                            </button>
                          </span>
                        </div>
                      </div>
                    </div>
                    <ul class="collapse complianceTrackerRecordItems" id="collapseComplianceTrackerRecords">
                      <li v-for="(operation, i) in service_module.operations" :key="i">
                        <div class="form-check d-flex col-xs-8 col-sm-8 mt-35" v-if="complianceServices[index][service.key].child[i]">
                          <label class="custom-checkbox">
                            <input type="checkbox" id="records" v-model="complianceServices[index][service.key].child[i].access" @change="toggleRecords('child',service.key,index)" />
                            <span class="select-check"></span>
                          </label>
                          <span class="pl-24 module-name fw-400">{{operation.name}}</span>
                        </div>
                      </li>
                    </ul>
                  </li>
                </ul>
            </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="col-sm-12 col-xs-12 col-md-12 footer_buttons">
      <div class="col-md-6 col-xs-6 col-sm-6  footer_left_button">
        <button type="button" class="btn btn-block blue_outline_back_button" @click="cancelAddTeam">{{ $t('back')}}</button>
      </div>
      <div class="col-xs-6 footer_right_buttons_section">
            <button type="button" class="btn btn-block blue_outline_cancel_button" @click="cancelAddTeam">{{ $t('cancel')}}</button>
            <button
              type="button"
              class="blue_save_changes_button"
              @click="addTeamMember"
              :disabled="disableButtonForAddTeam || loaderStatus"
            >{{ $t('save')}}</button>
      </div>
    </div>
     <loader :loadingStatus="loaderStatus"></loader>
  </div>
</template>
<script>
import $ from 'jquery';
import moment from 'moment';
import cloneDeep from 'clone-deep';
import Loader from '../../UIComponents/Loader.vue';
import EventBus from '../../../utils/event-bus';
import { addTeamMember } from '../../../apis/team';
import { getRoleBasedPermissions } from '../../../apis/rbac';
import { getAddonDetails } from '../../../apis/psm';
import servicesMixin from '../../UIComponents/mixins/servicesMixin';
import permissionsList from '../../UIComponents/mixins/rbacPermissionsMixin';

export default {
  mixins: [servicesMixin, permissionsList],
  props: ['roles', 'localDistributors', 'multi_factor_key', 'account_type_id'],
  data() {
    return {
      permissions: [],
      displayEmailErrorMsg: false,
      displayIpErrorMsg: false,
      team: {
        first_name: '',
        last_name: '',
        email: '',
        role: '',
        assigned_distributor_id: null,
        ip_address: '',
      },
      addMemberError: '',
      loaderStatus: false,
      servicesList: [],
      serviceId: null,
      memberName: '',
      userServiceList: [],
      addedServiceIds: [],
    };
  },
  components: {
    Loader,
  },
  methods: {
    getInitials(firstname, lastname) {
      return `${firstname ? firstname.charAt(0).toUpperCase() : ''}${lastname ? lastname.charAt(0).toUpperCase() : ''}`;
    },
    clearNotifcations() {
      this.$notify({
        clear: true,
        group: 'custom-notification',
      });
    },
    removeNull(array) {
      return array.filter((item) => item);
    },
    disablePermissionCheck(serviceid) {
      return this.servicesList.find((service) => service.id === serviceid).access;
    },
    revertOldPermissions(id, access) {
      if (!access) {
        const oldService = this.servicesList.find((service) => service.id === id);
        this.userServiceList.forEach((service, index) => {
          if (service.id === id) {
            this.userServiceList[index].access = access;
            this.userServiceList[index].modules = oldService.modules;
          }
        });
      }
    },
    emailVal() {
      const mailformat = /^([a-zA-Z0-9_\-\+\.]+)@([a-zA-Z-0-9-]+)((\.([a-zA-Z0-9-]){2,63}){1,3})$/; //eslint-disable-line
      this.displayEmailErrorMsg = false;
      if (this.team.email && !this.team.email.match(mailformat)) {
        this.displayEmailErrorMsg = true;
      }
    },
    ipAddressVal() {
       const ipAddressFormat = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/; //eslint-disable-line
      this.displayIpErrorMsg = false;
      if (this.team.ip_address && !this.team.ip_address.match(ipAddressFormat)) {
        this.displayIpErrorMsg = true;
      }
    },
    async validateTeamUpgrade() {
      this.loaderStatus = true;
      const addonAccountDetails = await getAddonDetails(
        JSON.parse(localStorage.getItem('userData')).account_id,
      );
      this.recordAddonService = addonAccountDetails.find(
        (each) => each.units === 'RECORDS',
      );
      this.teamAddonService = addonAccountDetails.find(
        (each) => each.units === 'USERS',
      );
      this.loaderStatus = false;
      if (this.teamAddonService) {
        if (
          this.teamAddonService.total_limit
            >= this.teamAddonService.default_limit
          && this.teamAddonService.is_active
          && moment().utc().format('YYYY-MM-DD HH:mm:ss') < this.teamAddonService.valid_until
          && moment().utc().format('YYYY-MM-DD HH:mm:ss') >= this.teamAddonService.valid_from
        ) {
          this.max_team_members = this.teamAddonService.total_limit;
        } else if (
          this.teamAddonService.total_limit
            >= this.teamAddonService.default_limit
          && this.teamAddonService.is_active
          && moment().utc().format('YYYY-MM-DD HH:mm:ss')
            > this.teamAddonService.valid_until
          && moment().utc().format('YYYY-MM-DD HH:mm:ss')
            >= this.teamAddonService.valid_from
        ) {
          this.max_team_members = this.teamAddonService.default_limit;
        }
        this.current_members = this.teamAddonService.current_utilization;
      }
    },
    savePermission() {
      this.updateUserPermission(this.userServiceList, this.serviceId);
    },
    async addTeamMember() {
      await this.validateTeamUpgrade();
      if (this.current_members < this.max_team_members) {
        this.loaderStatus = true;
        this.addMemberError = '';
        this.getServicesPermissions();
        const data = {
          first_name: this.team.first_name,
          last_name: this.team.last_name,
          memberEmailId: this.team.email,
          roleAssigned: this.team.role,
          rbac_permission_inst: this.userServiceList,
          ip_address: this.team.ip_address,
        };
        const response = await addTeamMember(data);
        this.loaderStatus = false;

        if (response) {
          if (!response.status) {
            this.addMemberError = response.message;
            this.clearNotifcations();
            this.$notify({
              type: 'error',
              title: this.$i18n.locale === 'Portuguese' ? 'Erro' : 'Error',
              text: this.$i18n.locale === 'Portuguese' ? 'Falha ao adicionar membro!' : 'Adding Member Failed!',
              group: 'custom-notification',
            });
          } else {
            this.clearNotifcations();
            this.$notify({
              type: 'success',
              title: this.$i18n.locale === 'Portuguese' ? 'Sucesso' : 'Success',
              text: this.$i18n.locale === 'Portuguese' ? 'Membro adicionado com sucesso!' : 'Member added successfully!',
              group: 'custom-notification',
            });
            this.$emit('getTeamMembers');
            this.cancelAddTeam();
          }
        } else {
          this.clearNotifcations();
          this.$notify({
            type: 'error',
            title: this.$i18n.locale === 'Portuguese' ? 'Erro' : 'Error',
            text: this.$i18n.locale === 'Portuguese' ? 'Falha ao adicionar membro!' : 'Adding Member Failed!',
            group: 'custom-notification',
          });
        }
      }
      $(`#${this.genericPopupId}`).modal({
        backdrop: 'static',
        keyboard: false,
      });
    },
    cancelAddTeam() {
      this.displayEmailErrorMsg = false;
      this.displayIpErrorMsg = false;
      this.team = {
        first_name: '',
        last_name: '',
        email: '',
        role: '',
        assigned_distributor_id: null,
        ip_address: '',
      };
      this.addTeamFlag = false;
      this.teamPermissionsFlag = false;
      this.$emit('cancelAddTeam');
      this.memberName = '';
      this.serviceId = null;
      this.userServiceList = [];
    },
    openPermissionsPopup(service) {
      this.serviceId = service.id;
      this.memberName = `${this.team.first_name} ${this.team.last_name}`;
      $('#permissionsAccess').modal({
        backdrop: 'static',
        keyboard: false,
      });
    },
    async getRoleBasedTemplate(roleId) {
      this.loaderStatus = true;
      const response = await getRoleBasedPermissions(roleId);
      this.loaderStatus = false;
      if (response) {
        const updatedResponse = this.removeNull(response.services).map((x) => ({
          ...x,
          modules: this.removeNull(x.modules).map((m) => ({ ...m, operations: this.removeNull(m.operations) })),
        }));
        response.services = updatedResponse;
        this.servicesList = cloneDeep(response.services);
        this.userServiceList = cloneDeep(this.servicesList);
      } else {
        this.clearNotifcations();
        this.$notify({
          type: 'error',
          title: this.$i18n.locale === 'Portuguese' ? 'Erro' : 'Error',
          text: this.$i18n.locale === 'Portuguese' ? 'Não é possível obter permissões padrão para a função!' : 'Unable to get default permissions for the role!',
          group: 'custom-notification',
        });
      }
      this.userServiceList.forEach((item) => {
        this.complianceServices = [];
        const { key } = item;
        this.complianceServices.push({ [key]: { parent: item.modules[0].access, child: item.modules[0].operations } });
      });
    },
    removeAssignedDistributorId() {
      this.team.assigned_distributor_id = null;
    },
    async validateFeatures() {
      this.permissions = [];
      const servicesList = ['REG_TRACKER'];
      const modulesList = ['REG_TRACKER_RECORDS', 'REG_TRACKER_REPORTS'];
      this.permissions = await this.permissionsList(servicesList, modulesList);
    },
  },
  async created() {
    await this.validateFeatures();
    EventBus.$on('resetTeams', () => {
      this.cancelAddTeam();
    });
  },
  beforeDestroy() {
    EventBus.$off('resetTeams');
  },
  computed: {
    disableButtonForAddTeam() {
      const mailformat = /^([a-zA-Z0-9_\-\+\.]+)@([a-zA-Z-0-9-]+)((\.([a-zA-Z0-9-]){2,63}){1,3})$/; //eslint-disable-line
      const ipAddressFormat = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/; //eslint-disable-line
      if (
        this.team.last_name && this.team.first_name
        && this.team.email
        && this.team.email.match(mailformat)
        && this.team.role
        && this.team.role === 6
        && this.team.assigned_distributor_id
      ) {
        if (this.team.ip_address && !this.team.ip_address.match(ipAddressFormat)) {
          return true;
        }
        return false;
      }
      if (
        this.team.last_name && this.team.first_name
        && this.team.email
        && this.team.email.match(mailformat)
        && this.team.role
        && this.team.role !== 6
      ) {
        this.removeAssignedDistributorId();
        if (this.team.ip_address && !this.team.ip_address.match(ipAddressFormat)) {
          return true;
        }
        return false;
      }
      if (this.team.role && this.team.role !== 6) {
        this.removeAssignedDistributorId();
        return true;
      }
      return true;
    },
  },
};

</script>

<style scoped>
.fw-400 {
  font-weight: 400 !important;
}
.multiselect-single-dropdown >>> .multiselect__option:hover {
  border:1px solid #0A99ff !important;
}
.multiselect-single-dropdown.multiselect--disabled >>> .multiselect__select{
  padding-top: 0px !important;
}
.product-class-ellipsis.multiselect-single-dropdown
>>> .multiselect__single,
.accredited-by-ellipsis.multiselect-single-dropdown
>>> .multiselect__single{
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 450px;
  margin-bottom: 0px;
}
.multiselect-single-dropdown.multiselect--active::before{
  content: none;
}
.multiselect--active
  >>> .multiselect__tags{
    border-radius: 3px !important;
    border-bottom: none;
    border-bottom-left-radius: 0px !important;
    border-bottom-right-radius: 0px !important;
    border-top: 1px solid #CCCCCC;
    border-right: 1px solid #CCCCCC;
    border-left: 1px solid #CCCCCC;
  }
  .multiselect--active >>> .multiselect__option--highlight:after{
    content: none !important;
  }
  .multiselect--active >>> .multiselect__option--selected.multiselect__option--highlight:after{
    content: none !important;
  }
  .multiselect--active >>> .multiselect__option--selected:after{
    content: none !important;
  }
.multiselect{
  min-height: 44px;
}
  .multiselect-single-dropdown
  >>> .multiselect__tags{
    border-radius: 3px;
    height: 34px;
    padding: 3px 40px 6px 11px;
    border: 1px solid #4D4D4D !important;
  }
  .multiselect-single-dropdown
  >>> .multiselect__select{
    padding-top: 7px !important;
  }
  .multiselect-single-dropdown.multiselect--disabled >>> .multiselect__select{
    padding-top:8px !important;
  }
  .multiselect-single-dropdown.multiselect--disabled {
        background: #ededed;
        pointer-events: none;
        opacity: 0.4;
  }
  .multiselect-single-dropdown
  >>> .multiselect__select:before{
    position: relative;
    right: 0;
    color: #4D4D4D;
    margin-top: 4px;
    border-color:  #4D4D4D transparent transparent;
    border-style: solid;
    border-width: 7px 7px 0;
    content: "";
    transform: rotate(0) !important;
    padding: 0px !important;
  }
  .multiselect-single-dropdown
  >>> .multiselect__option:hover{
    background: #FFFFFF !important;
  }
  .multiselect--active
  >>> .multiselect__select{
    padding-bottom: 6px !important;
    padding-top: 4px !important;
  }
  .multiselect-single-dropdown
  >>> .multiselect__content-wrapper .multiselect__option--highlight.multiselect__option--selected{
    border: 1px solid #0A99FF;
  }
  .multiselect-single-dropdown.multiselect--active
  >>> .multiselect__option--selected{
    background: #FFFFFF !important;
    border: 1px solid #0A99FF;

  }
  .multiselect-single-dropdown
    >>> .multiselect__option--selected:before {
    content: none;
  }
  .multiselect--active
  >>> .multiselect__tags::after{
    content: '';
    display: flex;
    align-items: center;
    position: absolute;
    bottom: 0;
    left: 11px;
    right: -13px;
    border: 0.5px solid #CCCCCC !important;
    opacity:0.5;
    width: 95%;

  }
  .multiselect-single-dropdown
  >>> .multiselect__single {
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    color: #4D4D4D;
    overflow: visible;
    padding-left:0px;
  }
  .multiselect-single-dropdown
  >>> .multiselect__placeholder {
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    color: #999999;
    overflow: visible;
  }
  .multiselect-single-dropdown >>> .multiselect__input::placeholder{
     color: #4D4D4D !important;
     padding-left:4px !important
  }
.multiselect--active
  >>>  .multiselect__single,
  .multiselect--active
  >>> .multiselect__placeholder{
    padding: 1px 40px 4px 0px;
    display: inline !important;
  }
 .multiselect--active
  >>> .multiselect__input{
    padding-left: 1px !important;
    padding-top: 4px !important;
    padding-bottom: 4px;
    margin-bottom: 0px;
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    color: #4D4D4D;
  }
  .multiselect-single-dropdown >>> .multiselect__input{
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    color: #4D4D4D;
    padding-top: 1px !important;
  }
  .multiselect-single-dropdown
  >>> .multiselect__content{
    margin-top: 5px;
  }
  .multiselect-single-dropdown
  >>> .multiselect__content .multiselect__element span{
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    color: #4D4D4D;
  }
  .multiselect-single-dropdown
  >>> .multiselect__content .multiselect__element .multiselect__option{
    padding-left: 16px;
    padding-top:11px;
    padding-bottom: 10px;
    padding-right: 0px;
  }
  @media screen and (max-width: 1025px) {
    .multiselect--active
  >>> .multiselect__tags::before{
    left: 10px;
    width:94%
  }
}
.multiselect-single-dropdown.multiselect--active
>>> .multiselect__content-wrapper{
    border:1px solid #CCCCCC;
    border-top: none;
    border-top-left-radius: 0px;
    border-top-right-radius: 0px;
    margin-top: 0px;
    max-height: 229px !important;
    border-bottom-left-radius: 3px;
    border-bottom-right-radius: 3px;
  }
  .multiselect-single-dropdown
  >>> .multiselect__content-wrapper{
    -webkit-box-shadow:none;
     box-shadow: none;
  }
.module-name {
  color: #3E3E3E;
  font-size: 16px;
  font-weight: 600;
}
.custom-error-class{
  margin-top: 0px;
  margin-bottom: 5px;
  color: #E12D33;
  list-style-type: none;
  display: block;
  padding-top: 12px;
  font-size: 14px;
}
.billing-info {
  margin-bottom: 32px;
  padding-left: 34px;
  color: #333;
  font-size: 18px;
  font-weight: 600;
}
.profile-pic-edit {
  width: 180px;
  height: 180px;
  float: unset;
  border-radius: 50%;
}
.profile-pic-title-edit {
  display: inline-block;
  background:#CCCCCC;
  color: #3E3E3E;
  text-align: center;
  font-size: 50px;
  font-weight: 500;
}
.initials {
  margin-top: 35%;
  display: flex;
  justify-content: center;
  line-height: 59px;
}
.mb-22{
  margin-bottom: 22px !important;
}
.pl-13{
  padding-left: 13px !important;
}
.mt-35 {
  margin-top: 35px !important;
}
.pt-40 {
  padding-top: 40px !important;
}
.pr-6{
  padding-right: 0px;
}
.team-wrapper::-webkit-scrollbar {
  width: 6px;
}
.team-wrapper::-webkit-scrollbar-thumb {
  background: #D9D9D9;
  border-top-left-radius: 18px;
  border-bottom-left-radius: 18px;
}
.team-wrapper::-webkit-scrollbar-track-piece:end {
  margin-bottom: 20px;
}
.team-wrapper::-webkit-scrollbar-track-piece:start {
  margin-top: 20px;
}
.field-name {
  font-size: 16px;
  line-height: 19px;
  color: #3e3e3e;
  margin-bottom: 7px;
}
.field-name:after {
  content: '*';
  font-size: 16px;
  color: #C02032;
  position: relative;
  top: -1px;
  margin-left: 4px;
}
input::placeholder{
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 300;
  font-size: 16px;
  line-height: 25px !important;
  color: #999999;
}
.pt-15 {
  padding-top: 15px;
}
.resources {
  padding-bottom: 50px;
}
.form-control, .form-control:focus {
  padding-top: 10px;
  padding-bottom: 10px;
  min-height: 34px;
  border: 1px solid #4D4D4D;
  border-radius: 3px;
  font-size: 16px;
  /* line-height: 25px; */
  color: #4d4d4d;
}
.serviceAccess{
  padding-right: 5px;
}
.hr-line{
  padding-right: 10px;
}
.hr-line hr{
  border-top: 1px solid #D3D3D3;
}
.serviceAccessText{
  margin-left: 10px;
  color: #333;
  font-size: 16px;
  font-weight: 600;
}
.horizontalLineOne{
  margin: 0 10px;
  border-top: 1px solid #D3D3D3;
}
.complianceTrackerOuter{
  margin-right: 28px;
  margin-left: 15px;
  padding-top: 18px;
}
.horizontalLineTwo{
  margin-left:113px;
  margin-right:82px;
}
.complianceTracker .greenCheckMark .img {
  width: 17px;
  height: 17px;
}
.complianceTracker {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  /* padding:0px; */
}
.complianceTracker .greenCheckMark {
  display:flex;
  align-items: center;
  padding-top: 5px;
}
.complianceTracker .complianceTrackerCarret {
  display:flex;
  align-items: center;
  justify-content: flex-end;
}
.complianceTracker .complianceTrackerText {
  margin-left: 7px;
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 0px;
  margin-top: 0px;
  color: #333;
}
.downCarret,
.upCarret{
  width: 19px;
  height: 19px;
}
ul {
  margin-bottom: 0px;
  padding: 0px;
}
ul li {
  list-style: none;
}
li a {
  text-decoration: none;
}
.wrap-content {
  display: block;
  margin-left: 44px !important;
}
li.main-content span button[aria-expanded="true"] img.upCarret {
  display: inline-block;
}
li.main-content span button[aria-expanded="true"] img.downCarret {
  display: none;
}
li.main-content span button img.downCarret {
  display: inline-block;
  transform: rotate(180deg);
}
li.main-content span button img.upCarret {
  display: none;
}
.complianceTrackerRecords {
  margin-left: 50px;
  display:flex;
  align-items: center;
  justify-content: flex-start;
}
.complianceTrackerRecords .carretTwo {
  display:flex;
  align-items: center;
  justify-content:flex-end;
  padding-right:55px;
}
.complianceTracker .complianceTrackerCarret button,
.complianceTrackerRecords .carretTwo button {
  border: none;
  background-color: transparent !important;
  padding-top: 0px;
}

.complianceTrackerRecordItems li,
.complianceTrackerReportItems li{
  margin-left: 78px;
}

.serviceAccess .form-check-input{
  width: 18px !important;
  height: 18px !important;
  background: #01518A;
  accent-color:  #01518A;
  border: 2px solid #000000 !important;
}
.serviceAccess .form-check{
  margin-top: 26px;
}
.serviceAccess .form-check .form-check-label{
  color: #3E3E3E;
  margin-left: 10px;
}
.footer_left_button{
  display: flex;
  align-items: center;
  justify-content: flex-start;
  z-index: 100;
  background: #ffffff;
  padding-top: 20px;
}
.blue_outline_back_button{
    background-color: #fff;
    border: 1px solid #000001;
    height: 44px;
    width: auto;
    color: #000;
    font-size: 18px;
    font-weight: 600;
    border-radius: 3px;
    padding: 9px 16px;
    /* box-shadow: 4px 4px 10px rgba(0, 0, 0, 0.25); */
}

.footer_right_buttons_section{
  display:flex;
  align-items: center;
  justify-content: flex-end;
  column-gap: 15px;
  background: #ffffff;
  padding-top: 20px;
  /* padding:6px 16px !important; */
  border-radius: 3px;
  padding-right: 0px;
}
.blue_outline_cancel_button{
    background-color: #E6E6E6;
    border: none;
    height: 44px;
    color: #404040;
    font-size: 18px;
    font-weight: 600;
    border-radius: 3px;
    padding: 10px 16px !important;
    width: auto;
}
.blue_save_changes_button, .blue_save_changes_button:hover{
    background-color: #01518a;
    border: none;
    height: 44px;
    cursor: pointer;
    color: #fff;
    font-size: 18px;
    font-weight: 600;
    border-radius: 3px;
    margin-top: 0px !important;
    padding: 10px 16px !important;
    width: auto;
}
.footer_right_buttons_section button:disabled{
  cursor: not-allowed;
}
@media (max-width: 1300px){
  .footer_buttons{
    padding-left: 15px !important;
  }
}
@media screen and (max-width: 600px) {
  .footer_buttons{
    display:flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    row-gap: 15px;
    width: 100%;
  }
  .footer_right_buttons_section,
  .footer_left_button {
    flex-direction: column;
    row-gap: 15px;
    width: 100%;
  }
  .blue_outline_back_button,
  .blue_outline_cancel_button,
  .blue_save_changes_button{
    width: 100%;
  }
}
.pb-20{
    padding-bottom:20px;
}
.footer_buttons{
  padding-top: 10px;
  position: absolute;
  bottom: 0%;
  padding-bottom: 16px;
  display: flex;
  column-gap: 16px;
  z-index: 100;
  right: 0;
}
.team-wrapper {
  margin-bottom: 10%;
  padding-right: 5px;
  padding-left: 27px;
}
.mr-bt-5p {
  margin-bottom: 13%;
}
.mr-bt-28{
  margin-bottom: 29px;
}
.mb-26 {
  margin-bottom: 26px;
}
.mb-77 {
  margin-bottom: 77px;
}
.bt-border {
  border-bottom: 1px solid #bdbdbd;
}
.txt-alg-rt {
  text-align: right;
}
.checkbox.cust_checkbox_rbac {
  display: inline-block;
  cursor: pointer;
}
.checkbox {
  position: relative;
  margin-top: 10px;
  margin-bottom: 5px;
}
input[type="checkbox"] {
  z-index: 1;
  width: 18px !important;
  height: 18px !important;
  left: 0;
  top: 0;
  margin: 0 !important;
}
.checkbox label:before {
  content: "";
  width: 18px !important;
  height: 18px !important;
  border: 2px solid #000000;
  display: inline-block;
  position: absolute;
  left: 0;
  top: 0;
}
.checkbox input[type="checkbox"]:checked + label:before {
  background-color: #01518A;
  background-image: url(/static/images/icons/checkbox.svg);
  background-size: 12px 16px;
  background-repeat: no-repeat;
  background-position-x: center;
}
.bt-border{
  border-bottom: 1px solid #BDBDBD;
}
.edit-lnk{
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 37px;
  text-align: right;
  padding-right: 15%;
  color: #2F80ED;
  cursor: pointer;
}
.mt-4{
  margin-top: 4px;
}
.cust_label {
  display: inline-block;
  margin-left: 15px;
  vertical-align: super;
  font-size: 14px;
  font-weight: 300;
}
.label-selected{
    color: #0B3C61;
    font-weight: 500;
}
.link-disabled{
    opacity: 0.4;
}
@media screen and (max-width: 767px) {
  .bt-border {
    padding-bottom: 10px;
  }
    .cust_checkbox_rbac {
    margin-left: 5px !important;
  }
}
@media screen and (min-width: 768px) {
  .hide-sm {
    display: none;
  }
}
/* iphoneX landscape  */
@media (device-width: 812px) and (device-height: 375px){
  .team-wrapper {
    height: 52vh;
  }
}

/* iphone5 landscape and below */
@media (max-width: 640px) and (max-height: 360px){
  .team-wrapper {
    height: 45vh;
  }
}
/* iphone 6 and 6+ landscape  */
@media (device-width: 736px) and (device-height: 414px), (device-width: 667px) and (device-height: 375px){
  .team-wrapper {
    height: 48vh;
  }
}
</style>
